
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './passive-being-explanation';
const mainimage = '/Images/Passivebeing1.webp';


const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "passivebeing" },
];

const Passivebeing = () => (
  <GrammarPageLayout
    level="B2"
    title="Passivebeing"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English “Being” and Passive Exercises"
    seoDescription="Advanced passive forms with continuous and perfect aspects. B2 level practice."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);



export default Passivebeing;

